module.exports = __webpack_public_path__ + "static/impress-MONEI-2e4d98c95a009bfda90251535ab26443.png";